import { render, staticRenderFns } from "./BaseComp.vue?vue&type=template&id=00a8d981&"
import script from "./BaseComp.vue?vue&type=script&lang=js&"
export * from "./BaseComp.vue?vue&type=script&lang=js&"
import style0 from "./BaseComp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports